import { FC } from 'react';

import dcCbeLogo from '../../assets/img/partners/dc_cbe_logo.jpg';
import dolLogo from '../../assets/img/partners/dol_logo.jpg';
import morganEdacLogo from '../../assets/img/partners/morgan_edac_logo.jpg';
import projectWLogo from '../../assets/img/partners/project_w_logo.jpg';
import ramwLogo from '../../assets/img/partners/ramw_logo.jpg';
import wardInfinityLogo from '../../assets/img/partners/ward_infinity_logo.jpg';

const PARTNERS = [
  { logo: wardInfinityLogo, alt: 'Ward Infinity' },
  { logo: projectWLogo, alt: 'Project W' },
  { logo: ramwLogo, alt: 'Restaurant Association Metropolitan Washington' },
  { logo: dcCbeLogo, alt: 'DC Certified Business Enterprise' },
  { logo: morganEdacLogo, alt: 'Morgan EDAC' },
  { logo: dolLogo, alt: 'Dreaming Out Loud' },
];

/** Programs and organizations HomeCook works alongside, shown under the hero. */
export const PartnerTrustStrip: FC = () => (
  <section aria-label="Programs working with HomeCook" className="relative border-y border-[#E4EEF1] bg-white opacity-80">
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary-400/50 to-transparent"
    />
    <div className="mx-auto flex w-full max-w-[1450px] flex-col gap-6 px-6 py-8 lg:flex-row lg:items-center lg:gap-12 lg:px-12">
      <div className="shrink-0">
        <p className="font-raleway text-[12px] font-bold uppercase tracking-[0.16em] text-primary-100/70">
          Working alongside
        </p>
        <p className="mt-1 max-w-[220px] font-open-sans text-[13px] text-muted">
          Incubators and organizations that support the culinary industry
        </p>
      </div>
      <ul className="flex flex-1 flex-wrap items-center justify-evenly gap-x-12 gap-y-6">
        {PARTNERS.map((partner) => (
          <li key={partner.alt}>
            <img
              src={partner.logo}
              alt={partner.alt}
              loading="lazy"
              className="h-[56px] w-auto max-w-[160px] object-contain opacity-65 grayscale transition duration-200 hover:opacity-100 hover:grayscale-0"
            />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default PartnerTrustStrip;
